export default __webpack_public_path__ + "static/12-carnival-0fff8c999aa5277430b056a65753a1b4.png";